"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.computeOrder = computeOrder;
const compute_item_1 = require("../cart/compute-item");
const discounts_1 = require("../discounts/discounts");
const fees_1 = require("../delivery/fees");
const apply_1 = require("../promotions/apply");
const taxes_1 = require("./taxes");
function sum(list, selector) {
    return list.reduce((total, item) => total + selector(item), 0);
}
// Ordre des opérations (v1 conservé, spec §3.2) : lignes → promotions →
// remises (ciblées puis globales, séquentielles, dans applyDiscounts) →
// frais de livraison → plancher 0 appliqué APRÈS les frais
// (apps/os/src/v1/lib/promotion.ts:246-254).
//
// Les remises de commande des promotions (`orderDiscount`) entrent dans le
// pipeline des remises comme une étape globale interne, AVANT les remises
// utilisateur : elles se répartissent donc sur les lignes — et sur leurs parts
// TVA — au plus fort reste, exactement comme une remise globale (Task 3).
function computeOrder(input) {
    const computed = input.items.map((item) => (0, compute_item_1.computeItem)(item, input.mode));
    const promoted = (0, apply_1.applyPromotions)(computed, input.promotions ?? [], input.mode);
    const perItem = promoted.items.map((item) => item.promotionDiscount);
    const orderPromotionTotal = sum(promoted.promotions, (promotion) => promotion.orderDiscount);
    const { items, discounts } = (0, discounts_1.applyDiscounts)(computed, input.discounts ?? [], {
        perItem,
        order: orderPromotionTotal,
    });
    const subtotal = sum(items, (item) => item.subtotal);
    // Montant de promotion effectivement appliqué (plafonné par applyPromotions
    // puis par applyDiscounts) : c'est lui qui doit fermer le total.
    const promotionsTotal = sum(items, (item) => item.promotionDiscount);
    const discountsTotal = sum(discounts, (discount) => discount.amount);
    const fees = (0, fees_1.deliveryFees)({
        mode: input.mode,
        zone: input.delivery?.zone,
        totalAfterDiscounts: subtotal - promotionsTotal - discountsTotal,
    });
    // Promotions et remises sont déjà plafonnées par ligne, donc
    // subtotal − promotionsTotal − discountsTotal ≥ 0 toujours : le plancher
    // n'est qu'une garde, jamais un point de clampage effectif avant les frais.
    const total = Math.max(0, subtotal - promotionsTotal - discountsTotal + fees);
    const shares = [
        ...items.flatMap((item) => item.vatSharesAfterDiscount),
        // Les frais de livraison forment une part TVA à part, à la taxe fournie
        // par l'appelant (R8) — jamais retrouvée par nom dans le catalogue.
        ...(fees > 0 && input.delivery ? [{ tax: input.delivery.tax, amount: fees }] : []),
    ];
    return {
        items,
        promotions: promoted.promotions,
        discounts,
        deliveryFees: fees,
        subtotal,
        promotionsTotal,
        discountsTotal,
        total,
        vat: (0, taxes_1.computeVatBreakdown)(shares),
    };
}
